import React from "react";
import { Warning } from "@phosphor-icons/react";

// Displays the "Produk perlu reorder" banner at the top of Sales Orders.
// Renders nothing when there are no alerts so the parent can drop this in
// unconditionally.
export default function LowStockAlertPanel({ alerts }) {
  if (!alerts?.length) return null;
  return (
    <div className="border border-amber-500/50 bg-amber-50 p-4 mb-6" data-testid="product-low-stock-panel">
      <div className="flex items-center gap-2 text-amber-800 font-bold uppercase tracking-wider text-xs mb-2">
        <Warning size={16} weight="bold" /> {alerts.length} Produk Perlu Reorder (agregat sisa &le; min per produk)
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
        {alerts.map((a) => (
          <div key={a.produk_id} className="border border-amber-300 bg-white p-2 text-xs">
            <div className="font-bold flex items-center justify-between">
              <span>{a.produk_nama}</span>
              <span
                className={`px-1.5 py-0.5 border text-[9px] uppercase font-bold ${
                  a.severity === "critical"
                    ? "border-red-500 text-red-700 bg-red-50"
                    : "border-amber-500 text-amber-700 bg-amber-50"
                }`}
              >
                {a.severity === "critical" ? "Kritis" : "Rendah"}
              </span>
            </div>
            <div className="font-mono text-[10px] text-muted-foreground mt-1">
              Sisa: <span className="font-bold text-foreground">{a.kuantiti_sisa}</span> / Min: <span className="font-bold text-foreground">{a.min_reorder}</span> · {a.so_aktif_count} SO
            </div>
          </div>
        ))}
      </div>
      <p className="text-[10px] text-amber-700 mt-2">
        Ambang min reorder diatur per produk di halaman <a href="/products" className="underline font-bold">Master Produk</a>.
      </p>
    </div>
  );
}
